<template>
    <div v-if="activeCustomer.firstname" class="bg-info text-black container">
        <template v-if="loading">Load delivery distance...</template>
        <template v-else-if="error">
            {{ error }}
        </template>
        <template v-else>
            <template v-if="branchList.length > 0">
                <div>Customer address can be delivered from</div>
                <div class="row">
                    <q-chip
                        dense
                        v-for="(item, index) in branchList"
                        :key="`${item}${index}`"
                        clickable
                        @click="onChooseBranch(item)"
                        color="primary"
                        text-color="white"
                        square
                        :outline="currentBranch !== item.br_code"
                    >
                        {{ item.store_name }}
                    </q-chip>
                </div>
            </template>
            <template v-else>
                <div>Customer address is nationwide delivery</div>
            </template>
        </template>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { mini, getBranchAddress } from "@/settings/branchs";
export default {
    name: "CartDeliveryFrom",
    data() {
        return {
            loading: true,
            branchList: [],
            error: null,
        };
    },
    computed: {
        ...mapState({
            activeCustomer: (state) => state["activeCustomer"]["customer"],
        }),
        currentBranch() {
            const branch = this.$store.state["branch"]["branch"];
            if (branch) {
                return parseInt(branch.code);
            }
            return null;
        },
    },
    watch: {
        activeCustomer: {
            handler: function (value) {
                console.log("watch activeCustomer", value);
                this.loadPolygon();
            },
        },
    },
    mounted() {
        this.loadPolygon();
    },
    methods: {
        async loadPolygon() {
            try {
                this.loading = true;
                const apikey = await this.$services.authentication.getApikey();
                if (apikey) {
                    const customer = this.$store.state["activeCustomer"];
                    if (customer) {
                        if (customer["customer"]) {
                            if (customer["customer"]["address"]) {
                                if (
                                    customer["customer"]["address"].length > 0
                                ) {
                                    const address =
                                        customer["customer"]["address"][0];

                                    const result =
                                        await this.$services.polygon.getDeliveryCost(
                                            address.location,
                                            apikey.key
                                        );

                                    let includeHQ = false;
                                    for (
                                        let index = 0;
                                        index < result.length;
                                        index++
                                    ) {
                                        if (
                                            result[index].eligible_to_shop_at_33
                                        ) {
                                            includeHQ = true;
                                            break;
                                        }
                                    }

                                    if (includeHQ) {
                                        const b33 = result.findIndex(
                                            (b) => b.br_code === 1000
                                        );

                                        if (b33 < 0) {
                                            result.push({
                                                isInPolygon: true,
                                                br_code: 1000,
                                                store_name: "Sukhumvit 33",
                                            });
                                        }
                                    }

                                    this.branchList = result;
                                    console.log(result);

                                    if (this.branchList.length == 0) {
                                        // change branch to sukhumvit 33
                                        const b =
                                            getBranchAddress("Sukhumvit 33");
                                        this.$store.dispatch(
                                            "branch/setBranch",
                                            b
                                        );
                                    }
                                }
                            }
                        }
                    }
                }
                this.loading = false;
            } catch (error) {
                console.warn(error);
                this.error = error;
            }
        },
        async onChooseBranch(branch) {
            console.log("onChooseBranch");

            if (this.currentBranch === branch.br_code) {
                return;
            }

            // switch branch
            const b = getBranchAddress(branch.store_name);
            this.$store.dispatch("branch/setBranch", b);
        },
    },
};
</script>

<style scoped>
.container {
    padding: 0px 16px;
}
</style>
